import { IDimension as ICommonDimension } from '@aon/tws-common-ui-questions/build/lib/models/dimensions/IDimension';
import axios from 'axios';
import Constants from '../constants';
import { ICustomDimensionEditModel, IMoveSurveyQuestionsToNewDimensionRequest } from '../models';

export async function getSurveyDimensions<T = ICommonDimension>(surveyId: number, includeAllDimensions = false): Promise<T[]> {
	const res = await axios.get(getSurveyDimensionUrl(surveyId) + `?includeAllDimensions=${includeAllDimensions}`);
	return res.data;
}

export async function addSurveyDimension(customDimension: ICustomDimensionEditModel) {
	customDimension.ownerId = 0;
	const url = getSurveyDimensionUrl(customDimension.surveyId);
	const res = await axios.post(url, customDimension);
	return res.data;
}

export async function copySurveyDimension(customDimension: ICustomDimensionEditModel) {
	const url = getSurveyDimensionUrl(customDimension.surveyId) + '/' + customDimension.surveyDimensionId + '/copy';
	const res = await axios.post(url, customDimension);
	return res.data;
}

export async function getSurveyDimension(surveyId: number, dimensionId: number): Promise<ICustomDimensionEditModel> {
	const url = getSurveyDimensionUrl(surveyId) + '/' + dimensionId;
	const res = await axios.get(url);
	return res.data;
}

export async function editSurveyDimension(customDimension: ICustomDimensionEditModel) {
	const url = getSurveyDimensionUrl(customDimension.surveyId) + '/' + customDimension.surveyDimensionId!;
	const res = await axios.put(url, customDimension);
	return res.data;
}

export async function removeSurveyDimension(surveyId: number, surveyDimensionId: number) {
	const url = getSurveyDimensionUrl(surveyId) + '/' + surveyDimensionId;
	const res = await axios.delete(url);
	return res.data;
}

export async function addQuestionsToSurveyDimension(surveyId: number, surveyDimensionId: number, surveyQuestionIds: number[]) {
	const url = getSurveyDimensionUrl(surveyId) + '/' + surveyDimensionId + '/add-questions';
	const res = await axios.post(url, surveyQuestionIds);
	return res.data;
}

export async function moveQuestionsToNewSurveyDimension(
	surveyId: number,
	surveyDimensionId: number,
	moveSurveyQuestionsToNewDimensionRequest: IMoveSurveyQuestionsToNewDimensionRequest,
) {
	const url = getSurveyDimensionUrl(surveyId) + '/' + surveyDimensionId + '/move-questions';
	const res = await axios.post(url, moveSurveyQuestionsToNewDimensionRequest);
	return res.data;
}

export async function removeQuestionsFromDimension(surveyId: number, surveyDimensionId: number, surveyQuestionIds: number[]) {
	const url = getSurveyDimensionUrl(surveyId) + '/' + surveyDimensionId + '/remove-questions';
	const res = await axios.post(url, surveyQuestionIds);
	return res.data;
}

function getSurveyDimensionUrl(surveyId: number) {
	return Constants.SURVEY_BUILDER_DIMENSIONS_API_URL.replace('{surveyId}', surveyId.toString());
}

export async function getDimensionsV2() {
	const res = await axios.get(Constants.API_V2_DIMENSIONS_URL + '?includedResources=Languages&publicationStatuses=2');
	return res.data;
}
